import { useEffect } from "react";
import { useSnapshot } from "valtio";

import { useWindowResize } from "hooks/useWindowResize";
import { Pagination } from "common/UIKit/Pagination";
import { TestsTableMobile } from "../TestsTableMobile";
import { TestsTable } from "../TestsTable";
import { testAttemptListService } from "services/testAttemptListService";

import styles from "./TestsTaken.module.scss";

export const TestsTaken = () => {
  const { width } = useWindowResize();
  const { data, pageCount, page, sort, isFetching } = useSnapshot(
    testAttemptListService
  );

  useEffect(() => {
    testAttemptListService.fetch();
  }, []);

  const onSortChange = (
    sortBy: "name" | "finished_at" | "time_to_complete" | "started_at"
  ) => {
    if (sortBy === "name") {
      testAttemptListService.setOrder(sortBy, { priority: 2 });
    } else {
      testAttemptListService.clearOrder("name", false);
      testAttemptListService.setOrder(sortBy, { priority: 1 });
    }
  };

  if (data.length === 0 && !isFetching)
    return (
      <p className={styles.empty_message}>You don't have any Tests taken yet</p>
    );

  return (
    <>
      {width <= 1300 ? (
        <TestsTableMobile rows={data} />
      ) : (
        <TestsTable onSortChange={onSortChange} rows={data} sort={sort} />
      )}
      <Pagination
        pageCount={pageCount}
        currentPage={page}
        goTo={(page) => testAttemptListService.goTo(page)}
      />
    </>
  );
};
